export const TITLE = "Mahindra Electric Auto Price in India 2026 | Mahindra Tempo";

export const META_CONTENT = [
  {
    name: "description",
    content:
      "Mahindra electric auto price in India ranges from ₹3.4 - ₹4.4 lakhs. Explore Mahindra commercial vehicles, mileage, images, features & on-road prices.",
  },
  {
    name: "keywords",
    content:
      "Mahindra electric auto, Mahindra 3 wheeler, Mahindra electric vehicles, Mahindra three wheeler, Mahindra electric auto price, Mahindra commercial vehicles, Mahindra EV auto, Mahindra electric truck, Mahindra Tempo, Mahindra load auto, Mahindra trucks, Mahindra price in India, Mahindra dealers, Mahindra specifications, Mahindra features, Mahindra battery capacity, Mahindra range, Mahindra charging, Mahindra EMI, Mahindra financing, Mahindra test drive, Mahindra Tempo",
  },
  {
    name: "author",
    content: "Turno",
  },
  {
    name: "url",
    content: "https://www.turno.club/electric-commercial-vehicles/Mahindra",
  },
  {
    name: "robots",
    content: "INDEX,ARCHIVE,FOLLOW",
  },
  {
    name: "lang",
    content: "en",
  },
  {
    name: "viewport",
    content: "width=device-width, initial-scale=1",
  },
  {
    property: "og:url",
    content: "https://www.turno.club/electric-commercial-vehicles/Mahindra",
  },
  {
    property: "og:type",
    content: "website",
  },
  {
    property: "og:title",
    content: "Mahindra Electric Auto Price in India 2026 | Mahindra Tempo",
  },
  {
    property: "og:description",
    content:
      "Mahindra electric auto price in India ranges from ₹3.4 - ₹4.4 lakhs. Explore Mahindra commercial vehicles, mileage, images, features & on-road prices.",
  },
  {
    property: "og:image",
    content: "/logoIcon.png",
  },
  {
    property: "fb:app_id",
    content: "5796260583761767",
  },
  {
    property: "fb:pages",
    content: "646488286564232",
  },
  {
    name: "twitter:description",
    content:
      "Mahindra electric auto price in India ranges from ₹3.4 - ₹4.4 lakhs. Explore Mahindra commercial vehicles, mileage, images, features & on-road prices.",
  },
  {
    name: "twitter:title",
    content: "Mahindra Electric Auto Price in India 2026 | Mahindra Tempo",
  },
  {
    name: "twitter:site",
    content: "@Turno",
  },
  {
    name: "twitter:creator",
    content: "@Turno",
  },
  {
    name: "twitter:url",
    content: "https://www.turno.club/electric-commercial-vehicles/Mahindra",
  },
  {
    name: "twitter:app:id:googleplay",
    content: "com.customerapp.turno.turno_customer_application",
  },
  {
    name: "twitter:app:country",
    content: "IN",
  },
];

export const VEHICLE_LINK = "https://www.turno.club/electric-commercial-vehicles/Mahindra";

export const H1_HEADING = "Mahindra Electric Auto Price: Models, Features, and Financing";

export const ATF_CONTENT = {
  text: [
    "The Mahindra Electric Auto Price has become an important point of discussion for fleet owners and individual operators who want to maximize profits. As India observes an enormous shift toward green mobility, Mahindra Last Mile Mobility has emerged as the leader of the revolution with offerings like its reliable Treo and e-Alfa series. Whether you are looking for a Mahindra battery auto for passenger transport or a Mahindra electric loader for your logistics business, Mahindra offers a range of high-performance vehicles designed for Indian roads. With Turno, you can own a Mahindra electric auto with the lowest down payment and guaranteed resale value.",
  ],
};

export const ATF_NOTE =
  "Note: The Mahindra electric auto on road price includes RTO, insurance, and local taxes, which may vary by state.";

export const ATF_TABLE_HEADING = "Mahindra Electric Auto Price List in India (2026)";

export const ATF_TABLE_COLUMNS = [
  { key: "model", label: "Model" },
  { key: "type", label: "Type" },
  { key: "price", label: "Ex-Showroom Price (Approx)" },
  { key: "range", label: "Range per Charge" },
];

export const ATF_TABLE_DATA = [
  { model: "Mahindra Treo Plus", type: "Passenger", price: "₹3.85 Lakh onwards", range: "150 km", link: "/electric-commercial-vehicles/Mahindra/treo-plus" },
  { model: "Mahindra Zor Grand", type: "Cargo", price: "₹4.30 Lakh onwards", range: "85 km", link: "/electric-commercial-vehicles/Mahindra/Zor-Grand" },
  { model: "Mahindra Treo Zor", type: "Cargo", price: "₹3.40 Lakh onwards", range: "80 km", link: "/electric-commercial-vehicles/Mahindra/Treo-Zor" },
];

export const BRAND_HEADER_INFO = "Mahindra Trucks";

export const BRAND_DESCRIPTION = "Experience the Future of Electric Mobility with Mahindra Trucks from Turno. Mahindra Electric Autos are designed to provide clean, efficient, and sustainable transportation solutions for urban mobility and last-mile connectivity. Equipped with features like regenerative braking, comfortable seating, spacious cabins, and connectivity options they are a great and sustainable choice for mobility services, and small-scale goods transportation.";

export const PRICE_LIST_HEADER = "Mahindra Electric Auto Price List in India 2026";

export const PRICE_LIST_DESCRIPTION = "Explore the Mahindra electric auto price, providing an affordable and sustainable transportation solution for businesses. Mahindra trucks are poised to revolutionize the commercial transportation sector with their exceptional efficiency, reliability, and eco-friendliness. Here is a table displaying various Mahindra electric truck models and their corresponding price ranges:";

export const PROMISES_HEADER = "Why Mahindra Electric Vehicles From Turno?";

export const ADVANTAGES_HEADING = "Advantages of Mahindra Battery Auto";

export const ADVANTAGES_DESCRIPTION = "Switching to a Mahindra battery auto offers significant operational benefits. Here is why Mahindra is the preferred choice for thousands:";

export const BLOG_HEADER = "Turno Blogs on Mahindra";

export const USPS_HEADING = "Mahindra Commercial vehicles USPs:";

export const USPS_DESCRIPTION = "Mahindra electric commercial vehicles offer maintenance-free operations, ensuring hassle-free ownership. Choose savings and reliability with these Mahindra cargos that require minimal maintenance. Take home the Mahindra load auto for efficient and profitable transportation while enjoying the benefits of worry-free operations.";

export const MODELS_HEADER = "Mahindra Load Electric Commercial Vehicles:";

export const MODELS_DESCRIPTION = "Mahindra's EV Auto models offer versatile and sustainable transportation solutions:";

export const DEALER_HEADER = "Mahindra Electric Trucks Dealer Near Me:";

export const DEALER_DESCRIPTION = "As Mahindra continues to expand its reach and reputation, its presence is being felt across India. With a growing number of people opting for Mahindra's high-quality mobility solutions that offer great value for money, Turno brings you an exceptional range of Mahindra commercial vehicles at affordable prices. Head to Turno to explore and purchase Mahindra trucks that meet your needs and budget.";

export const FAQ_HEADING = "FAQs on Mahindra Electric Auto";

export const LOAN_HEADER = "Mahindra Load auto loan";

export const CTA_TEXT = "Get On Road Price";

export const CONNECT_HEADING = "Talk to Us";

export const CONNECT_SUBHEADING = "We help you find the best vehicle for your business with affordable financing. Connect with us now.";

export const CONNECT_CTA_TEXT = "Call us";

export const AVAILABLE_BRANDS_TITLE = "Available Brands";

export const SEO_FOOTER_CONTENT = [
  {
    heading: "About Mahindra Electric Auto Models",
    paragraphs: [
      "With a wide range of vehicles on offer, the Mahindra ev auto price is structured to cater to both the budget-conscious e-rickshaw segment and the high-performance L5 commercial segment. If you are looking for a Mahindra tempo price or a Mahindra toto price, check out the many models available at Turno, and explore easy financing options that are tailored to your fleet operations.",
    ],
  },
  {
    heading: "Mahindra Passenger Electric Autos",
    paragraphs: [
      "Engineered specifically for last-mile logistics, these models are the modern avatars of the classic Mahindra auto rickshaw, pairing the trust of Mahindra with the convenience and green initiative of modern EV rickshaws.",
    ],
    list: [
      {
        label: "Mahindra Treo Plus",
        text: "The flagship Mahindra electric auto passenger model which features a hefty 150 km range and hill-hold assist for added driving convenience.",
      },
      {
        label: "Mahindra e-Alfa Super",
        text: "Often referred to as the premium Mahindra toto, it is ideal for short-distance commutes with a focus on high passenger capacity, and its low Mahindra e rickshaw price makes it a stand out vehicle.",
      },
    ],
  },
  {
    heading: "Mahindra Cargo Electric Autos",
    paragraphs: [
      "For delivery and logistics, the Mahindra electric loader price offers the best value for cargo volume and payload.",
    ],
    list: [
      {
        label: "Mahindra Zor Grand",
        text: "A powerful cargo electric with a 12 kW motor, with a reasonable Mahindra electric pickup price, making it a prime contender for heavy delivery runs.",
      },
      {
        label: "Mahindra Treo Zor",
        text: "A versatile loader available in Pickup, Flatbed, and Delivery Van variants to suit diverse business needs.",
      },
    ],
  },
  {
    heading: "Financing Your Mahindra EV with Turno",
    paragraphs: [
      "Searching for a Mahindra electric auto on road price shouldn't be stressful. Turno makes the transition to electric seamless:",
    ],
    list: [
      {
        label: "Lowest Down Payment",
        text: "Start your business with a minimal upfront investment.",
      },
      {
        label: "Quick Financing",
        text: "Get your Mahindra electric tempo price financed with a paperless process and approvals in as little as 48 hours.",
      },
      {
        label: "Guaranteed Resale",
        text: "Turno offers a unique buyback guarantee, protecting the future value of your Mahindra battery auto.",
      },
    ],
  },
];

export const BREADCRUMB_ITEMS = [
  { label: "Home", href: "/" },
  { label: "Electric Commercial Vehicles", href: "/electric-commercial-vehicles" },
  { label: "Mahindra" },
];

export const BREADCRUMB_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://www.turno.club/",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Electric Commercial Vehicles",
      item: "https://www.turno.club/electric-commercial-vehicles",
    },
    {
      "@type": "ListItem",
      position: 3,
      name: "Mahindra",
      item: VEHICLE_LINK,
    },
  ],
};